import React from 'react'
import { Checkbox } from 'react-bootstrap'

export const SubmissionsFilter = ({ onChange, children, ...props }) => (
  <Checkbox
    onChange={onChange}
    data-test-id={`submissions-filter-${children.toLowerCase().split(' ').join('-')}`}
    {...props}
  >
    { children }
  </Checkbox>
)
